import ChallengeProgramSelector from './ChallengeProgramSelector';

export default ChallengeProgramSelector;
